/* GENERAL ROUTES */
export enum GeneralPath {
  ABOUT_US = '/about-us',
  AUTHORS = '/authors',
  BLOG = '/blog',
  CASE_STUDIES = '/case-studies',
  HOME = '/',
  GLOSSARY = '/glossary',
  LIBRARY = '/library',
  SERVICES = '/services',
  GLOSSARY_ALL = '/glossary',
  PRIVACY_POLICY = '/privacy-policy',
  AI_CONTENT_POLICY = '/ai-content-policy',
  TERMS_OF_SERVICE = '/terms-of-service',
  EU_PROJECTS = '/eu-projects',
  CONTACT = '/contact',
  THANKS = '/thanks',
  KNOWHUB = '/knowhub',
  INPRODUCT = '/inproduct',
  SMARTSEARCH = '/smartsearch',
}

/* BLOG ROUTES */
export enum BlogPath {
  ARTICLE = '/blog/:slug',
}

/* AUTHOR ROUTES */
export enum AuthorsPath {
  AUTHOR = '/authors/:slug',
}

/* CASE STUDIES ROUTES */
export enum CaseStudiesPath {
  CASE_STUDY = '/case-studies/:slug',
}

/* GLOSSARY ROUTES */
export enum GlossaryPath {
  GLOSSARY_DEFINITION = '/glossary/:slug',
}

/* DIRECTORY ROUTES */
export enum DirectoryPath {
  DIRECTORY = '/directory',
  DIRECTORY_DETAIL = '/directory/:slug',
}

/* LIBRARY ROUTES */
export enum LibraryPath {
  LIBRARY = '/library/:slug',
}

/* SERVICES ROUTES */
export enum ServicesPath {
  AI = '/ai',
  DESIGN = '/design-services',
  DEVELOPMENT = '/software-development-services',
  MVP_BUILDING = '/mvp-development',
  NO_CODE = '/no-code',
  DIRECTION_CHECK = '/direction-check',
  PRODUCT_DISCOVERY = '/product-discovery',
  SCOPE_BUILDING = '/scope-building',
  USER_TESTING = '/user-testing',
  UX_DESIGN = '/ux-design',
  UI_DESIGN = '/ui-design',
  PRODUCT_DESIGN = '/product-design',
  QUALITY_ASSURANCE = '/quality-engineering',
  DEDICATED_TEAM = '/dedicated-team',
  COOPERATION_MODELS = '/cooperation-models',
  AI_NATIVE_POD = '/ai-native-pod',
  MULTI_AGENT_SYSTEMS = '/multi-agent-systems',
  AI_AGENTS_FOR_TRAVEL = '/ai-agents-for-travel',
  AI_AGENTS_FOR_RETAIL = '/ai-agents-for-retail',
  AI_AGENTS_FOR_MANUFACTURING = '/ai-agents-for-manufacturing',
  AI_AGENTS_FOR_HEALTHCARE = '/ai-agents-for-healthcare',
  AI_AGENTS_FOR_FINANCIAL_SERVICES = '/ai-agents-for-financial-services',
  AI_AGENTS_FOR_INDUSTRIAL_OPERATIONS = '/ai-agents-for-industrial-operations',
  PLATFORM_ENGINEERING = '/platform-engineering',
}

export enum IndustriesPath {
  HOME = '/health-tech',
  HEALTHCARE = '/health-tech',
  EDTECH = '/ed-tech',
  AI = '/ai-tech',
  FINTECH = '/fin-tech',
  TRAVEL = '/travel-tech',
  FOOD_MANUFACTURING = '/food-manufacturing',
}

/* HELPERS */
type Path =
  | BlogPath.ARTICLE
  | AuthorsPath.AUTHOR
  | CaseStudiesPath.CASE_STUDY
  | GlossaryPath.GLOSSARY_DEFINITION
  | LibraryPath.LIBRARY;

export function getDynamicPath(path: Path, slug: string): string {
  return path.replace(':slug', slug);
}
